"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import {
  GA_MEASUREMENT_ID,
  META_PIXEL_ID,
  hasGoogleAnalytics,
  hasMetaPixel,
} from "@/lib/analytics";

/**
 * Loads Meta Pixel and GA4 when their IDs are configured, and reports the
 * client-side route changes that neither library detects on its own.
 */
export default function Analytics() {
  const pathname = usePathname();

  useEffect(() => {
    if (!pathname) return;

    if (hasMetaPixel) {
      window.fbq?.("track", "PageView");
    }

    if (hasGoogleAnalytics) {
      window.gtag?.("event", "page_view", { page_path: pathname });
    }
  }, [pathname]);

  if (!hasMetaPixel && !hasGoogleAnalytics) {
    return null;
  }

  return (
    <>
      {hasMetaPixel ? (
        <>
          <script
            id="meta-pixel"
            dangerouslySetInnerHTML={{
              __html: `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
document,'script','https://connect.facebook.net/en_US/fbevents.js');
fbq('init','${META_PIXEL_ID}');fbq('track','PageView');`,
            }}
          />
          <noscript>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              height="1"
              width="1"
              style={{ display: "none" }}
              alt=""
              src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`}
            />
          </noscript>
        </>
      ) : null}

      {hasGoogleAnalytics ? (
        <>
          <script
            async
            src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
          />
          <script
            id="ga4"
            dangerouslySetInnerHTML={{
              __html: `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}
gtag('js',new Date());gtag('config','${GA_MEASUREMENT_ID}');`,
            }}
          />
        </>
      ) : null}
    </>
  );
}
